import { apiRequest } from "@portal/lib/ky/utils";
import { SnapShot } from "@portal/types/snapshot";

export async function getSnapShot() {
  const response = await apiRequest<unknown, SnapShot>({
    method: "GET",
    url: "v1/customers/snapshot",
  });
  return await response.json();
}
